// extracted by mini-css-extract-plugin
export default {"paragraph":"Paragraph_paragraph__giI8F","strong":"Paragraph_strong__3wI28"};